/**
 * Substitutes `{target}` in copy that names what the road counts down to.
 *
 * Some UI strings genuinely need the name — "Only what Doomsday assumes you
 * know" says something a generic phrasing cannot. Hardcoding it was fine while
 * there was one project and wrong the moment there were two, so the strings
 * carry a token and this fills it from whatever catalog is loaded.
 */
export function withTarget(text: string, shortTitle: string): string {
  return text.replaceAll("{target}", shortTitle);
}
